import React from 'react';
import { DownloadOutlined, FileWordOutlined, FileExcelOutlined, FilePptOutlined, FileTextOutlined } from '@ant-design/icons';

// 从 AI 回复文本里提取报告下载链接（/reports/xxx 或 https://.../reports/xxx），供三个 AI 员工助手复用
export function extractReports(text) {
  const re = /(?:https?:\/\/[^\s"'<>()]*)?\/reports\/[^\s"'<>()]+/g;
  const out = [];
  let m;
  while ((m = re.exec(String(text || ''))) !== null) {
    const url = m[0];
    const filename = url.split('/').pop();
    if (!out.some(x => x.url === url)) out.push({ url, filename });
  }
  return out;
}

const EXT_ICON = {
  md: FileTextOutlined,
  docx: FileWordOutlined,
  xlsx: FileExcelOutlined,
  pptx: FilePptOutlined,
  html: FileTextOutlined,
};

// 报告下载按钮组：在 AI 消息气泡内、正文下方渲染（含图含文字，点击即下载/打开）
export default function ReportDownload({ text, color = 'var(--brand)' }) {
  const reports = extractReports(text);
  if (!reports.length) return null;
  return (
    <div style={{ marginTop: 10, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
      {reports.map((r, i) => {
        const ext = (r.filename.split('.').pop() || '').toLowerCase();
        const Icon = EXT_ICON[ext] || FileTextOutlined;
        const isHtml = ext === 'html';
        return (
          <a
            key={i}
            href={r.url}
            target="_blank"
            rel="noreferrer"
            download={isHtml ? undefined : true}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 6,
              padding: '5px 12px', borderRadius: 8,
              background: '#FFF1EC', border: '1px solid var(--brand-border)',
              color, fontSize: 13, fontWeight: 600, textDecoration: 'none',
            }}
          >
            <Icon style={{ color }} />
            {r.filename}
            {isHtml ? '（在线预览）' : <DownloadOutlined style={{ fontSize: 12, color: '#A99F94' }} />}
          </a>
        );
      })}
    </div>
  );
}
